jQuery(document).ready(function () {

    // Buttons
    jQuery(document).on("click", "button[data-research-type]:not(.active)", async function (e) {
        e.preventDefault();
        const button = jQuery(this);
        const dataType = button.attr("data-research-type");
        const dataId = button.attr("data-research-id");

        // buttons filter-buttons-sect__wp
        jQuery("button[data-research-type]").removeClass("active");
        button.addClass("active");
        // panels research-all-sect__wp
        jQuery(".research-all-sect__wp > [data-research-type]").removeClass("active");
        jQuery(`.research-all-sect__wp > [data-research-type="${dataType}"]`).addClass("active");

        // state
        const url = new URL(location);
        url.searchParams.set("slug", dataType);
        // add the hash
        url.hash = 'research_' + dataId;
        history.pushState({}, "", url);
    });

});